const action = "SEGMENT_CREATE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

export const createSegmentRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};

export const createSegmentSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearState = () => ({
  type: CLEAR
});

export const createSegmentFailure = (error) => ({
  type: FAILURE,
  payload: error
}); 